export default "__VITE_ASSET__D196JiT7__"